import { NextPage } from 'next'
import OurDealerScreen from '../screens/OurDealer'
import AppOurDealerScreen from '../screens/App-OurDealer'
import { ScreenWidthPort } from '../ScreenWidthContext'

export const OurDealer: NextPage = () => {
    const { showDesktopUI } = ScreenWidthPort()

    return (
        <>
            {showDesktopUI ? (<OurDealerScreen />) : (<AppOurDealerScreen />)}
        </>
    )
}
